import React, { ChangeEvent } from "react";
import { DateTime } from "../../../domain/fundamental/DateTime";
import dayjs from "dayjs";
import { Mount } from "../common/Mount";

// **** 注意 ****
// <input type="datetime"/>を利用しているのでIE11では動かない。
// 管理機能でのみ使うのでこれでよしとしている。ユーザー向け画面では決して使わないこと。
export function AdminDateTimePicker(props: AdminDateTimePickerProps) {
    const { currentDateTime, whenDateTimeChanged, isNullable } = props;

    const handleChanged = (e: ChangeEvent<HTMLDataElement>) => {
        const value = e.target.value;
        whenDateTimeChanged(value? DateTime.fromString(dayjs(value).format("YYYY-MM-DD HH:mm:ss")) : null);
    };

    const handleReset = () => {
        whenDateTimeChanged(null);
    };

    return (
        <div className={"admin_date_picker"}>
            <input type={"datetime-local"} value={currentDateTime? `${currentDateTime.date.format()}T${currentDateTime.time.formatHourMinute()}`: ""} onChange={handleChanged}/>
            <Mount if={isNullable === true}>
                <button onClick={handleReset}>リセット</button>
            </Mount>
        </div>
    );
}

export type AdminDateTimePickerProps = {
    currentDateTime: DateTime | null,
    whenDateTimeChanged: (input: DateTime | null) => void,
    isNullable?: boolean,
};
